import React from 'react';

const UPCOMING_LESSONS = [
  { title: 'Beginner Group Class', day: 'Mon', time: '4:00 PM', price: '$25', enrolled: 6, max: 8 },
  { title: 'Advanced Tactics', day: 'Wed', time: '6:00 PM', price: '$35', enrolled: 3, max: 4 },
  { title: 'Tournament Prep 1-on-1', day: 'Fri', time: '5:30 PM', price: '$50', enrolled: 1, max: 1 },
];

const STUDENTS = [
  { name: 'James K.', status: 'Member' },
  { name: 'Sofia R.', status: '8 Credits' },
  { name: 'Marcus L.', status: 'Member' },
  { name: 'Ava P.', status: '3 Credits' },
  { name: 'Daniel T.', status: '12 Credits' },
];

const LIBRARY_ITEMS = [
  { icon: 'fa-folder', label: 'Opening Prep', color: '#60a5fa', count: 12, access: 'Free' },
  { icon: 'fa-folder', label: 'Tactics', color: '#34d399', count: 8, access: 'Free' },
  { icon: 'fa-folder', label: 'Endgames', color: '#fb923c', count: 5, access: 'Members' },
  { icon: 'fa-folder', label: 'Lesson Recaps', color: '#a78bfa', count: 14, access: 'Shop' },
];

const ANALYTICS_STATS = [
  { icon: 'fa-users', label: 'Visitors', value: '1,247', color: '#60a5fa' },
  { icon: 'fa-arrow-right-to-bracket', label: 'Visits', value: '1,842', color: '#34d399' },
  { icon: 'fa-eye', label: 'Pageviews', value: '8,456', color: '#fb923c' },
  { icon: 'fa-layer-group', label: 'Views/Visit', value: '4.6', color: '#a78bfa' },
  { icon: 'fa-arrow-right-from-bracket', label: 'Bounce Rate', value: '12.3%', color: '#f472b6' },
  { icon: 'fa-clock', label: 'Avg Duration', value: '4m 32s', color: '#fbbf24' },
];

const FUNNEL_STEPS = [
  { label: 'Profile View', sub: 'Landed on your page', events: 1247, pct: null },
  { label: 'Coaching Click', sub: 'Clicked a package', events: 312, pct: '25%' },
  { label: 'Book Lesson', sub: 'Clicked to book', events: 86, pct: '28%' },
  { label: 'Checkout Start', sub: 'Started payment', events: 52, pct: '60%' },
  { label: 'Payment Complete', sub: 'Payment received', events: 42, pct: '81%' },
];

const SOURCES = [
  { name: 'Direct / None', visitors: 847, visits: 1204 },
  { name: 'Google', visitors: 186, visits: 198 },
  { name: 'Twitter', visitors: 112, visits: 142 },
  { name: 'Reddit', visitors: 68, visits: 74 },
  { name: 'YouTube', visitors: 34, visits: 38 },
];

const TOP_PAGES = [
  { page: '/', tag: 'Home', visitors: 892, pageviews: 3247 },
  { page: '/coaching', tag: 'Coaching', visitors: 234, pageviews: 567 },
  { page: '/library', tag: null, visitors: 187, pageviews: 423 },
  { page: '/shop', tag: 'Shop', visitors: 156, pageviews: 312 },
];


const AcademyShowcase = ({ onGetStarted }) => {
  return (
    <section className="py-12 md:py-24 bg-[#151515]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            One dashboard. Your entire chess business.
          </h2>
          <p className="text-gray-400 max-w-3xl mx-auto text-lg">
            Scheduling, payments, students, content, and analytics — all connected, all in one place. This is what running a coaching business should feel like.
          </p>
        </div>

        {/* Mock Dashboard */}
        <div className="max-w-6xl mx-auto rounded-2xl border border-white/10 overflow-hidden shadow-[0_0_60px_-15px_rgba(116,149,85,0.15)]">
          {/* Chrome Bar */}
          <div className="flex items-center gap-2 px-4 py-3 bg-[#0d0d0d] border-b border-white/10">
            <div className="flex gap-1.5">
              <div className="w-3 h-3 rounded-full bg-[#ff5f57]"></div>
              <div className="w-3 h-3 rounded-full bg-[#febc2e]"></div>
              <div className="w-3 h-3 rounded-full bg-[#28c840]"></div>
            </div>
            <span className="text-xs text-gray-500 ml-2 font-medium">Coach Dashboard</span>
          </div>

          {/* Dashboard Grid */}
          <div className="p-4 md:p-6 bg-[#111111] grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Upcoming Lessons - 2 cols wide */}
            <div className="md:col-span-2 bg-white/5 border border-white/10 rounded-xl p-4">
              <div className="flex items-center justify-between mb-4">
                <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">Upcoming Lessons</h4>
                <span className="text-xs text-chess-green font-medium">This Week</span>
              </div>
              <div className="space-y-2">
                {UPCOMING_LESSONS.map((lesson, i) => (
                  <div key={i} className="flex items-center justify-between p-2.5 rounded-lg bg-white/[0.03] border border-white/5">
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-white truncate">{lesson.title}</p>
                      <p className="text-xs text-gray-500 mt-0.5">{lesson.day} &middot; {lesson.time}</p>
                    </div>
                    <div className="flex items-center gap-3 ml-4">
                      <span className="text-sm font-semibold text-chess-green">{lesson.price}</span>
                      <div className="w-16 hidden sm:block">
                        <div className="w-full h-1.5 bg-white/10 rounded-full overflow-hidden">
                          <div
                            className="h-full bg-chess-green rounded-full"
                            style={{ width: `${(lesson.enrolled / lesson.max) * 100}%` }}
                          ></div>
                        </div>
                        <p className="text-[10px] text-gray-500 mt-1 text-right">{lesson.enrolled}/{lesson.max}</p>
                      </div>
                      {i === 0 && (
                        <span className="px-3 py-1 bg-blue-500 text-white text-xs font-bold rounded-lg cursor-default hidden sm:block">
                          JOIN
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Revenue */}
            <div className="bg-white/5 border border-white/10 rounded-xl p-4 flex flex-col">
              <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">Revenue</h4>
              <div className="text-3xl font-bold text-white mb-1">$2,340</div>
              <div className="flex items-center gap-2 mb-4">
                <span className="text-xs font-medium text-green-400 bg-green-400/10 px-2 py-0.5 rounded-full">
                  <i className="fas fa-arrow-up mr-1"></i>18%
                </span>
                <span className="text-xs text-gray-500">vs last month</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-400 mb-4">
                <i className="fas fa-calendar-check text-chess-green"></i>
                <span>24 sessions this month</span>
              </div>
              {/* Mini monthly bar chart */}
              <div className="flex items-end gap-1.5 mt-auto mb-3" style={{ height: 64 }}>
                {[680, 920, 1100, 1450, 1780, 2340].map((val, i) => {
                  const barHeight = Math.round((val / 2340) * 52);
                  return (
                    <div key={i} className="flex-1 flex flex-col items-center justify-end h-full">
                      <div
                        className={`w-full rounded-sm ${i === 5 ? 'bg-chess-green' : 'bg-white/10'}`}
                        style={{ height: barHeight }}
                      ></div>
                      <span className="text-[8px] text-gray-600 mt-1">{['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][i]}</span>
                    </div>
                  );
                })}
              </div>
              {/* Quick stats */}
              <div className="grid grid-cols-2 gap-2 pt-3 border-t border-white/5">
                <div>
                  <p className="text-[10px] text-gray-500">Avg / Session</p>
                  <p className="text-sm font-semibold text-white">$97.50</p>
                </div>
                <div>
                  <p className="text-[10px] text-gray-500">Active Students</p>
                  <p className="text-sm font-semibold text-white">12</p>
                </div>
              </div>
            </div>

            {/* Students */}
            <div className="bg-white/5 border border-white/10 rounded-xl p-4">
              <div className="flex items-center justify-between mb-4">
                <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">Students</h4>
                <span className="text-xs text-gray-500">12 active</span>
              </div>
              <div className="space-y-2.5">
                {STUDENTS.map((s, i) => (
                  <div key={i} className="flex items-center justify-between">
                    <span className="text-sm text-gray-300">{s.name}</span>
                    <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                      s.status === 'Member'
                        ? 'bg-chess-green/15 text-chess-green'
                        : 'bg-white/5 text-gray-400'
                    }`}>{s.status}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Content Library - macOS folder style */}
            <div className="md:col-span-2 bg-white/5 border border-white/10 rounded-xl p-4">
              <div className="flex items-center justify-between mb-4">
                <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">Content Library</h4>
                <span className="text-xs text-gray-500">{LIBRARY_ITEMS.reduce((a, b) => a + b.count, 0)} items</span>
              </div>
              <div className="grid grid-cols-4 gap-1 sm:gap-3">
                {LIBRARY_ITEMS.map((item, i) => (
                  <div key={i} className="flex flex-col items-center gap-1 sm:gap-2 p-1 sm:p-2 rounded-lg hover:bg-white/[0.03] transition-colors cursor-default">
                    {/* macOS-style folder icon */}
                    <div
                      className="w-12 h-12 sm:w-[72px] sm:h-[72px] rounded-[14px] flex items-center justify-center"
                      style={{ background: `color-mix(in srgb, ${item.color} 12%, transparent)` }}
                    >
                      <i
                        className="fas fa-folder text-xl sm:text-3xl"
                        style={{ color: item.color }}
                      ></i>
                    </div>
                    <div className="text-center">
                      <p className="text-[9px] sm:text-xs text-gray-300 font-medium leading-tight whitespace-nowrap">{item.label}</p>
                      <p className="text-[8px] sm:text-[9px] text-gray-500">{item.count} items</p>
                      <span
                        className="inline-block mt-0.5 sm:mt-1 px-1 sm:px-1.5 py-0.5 rounded text-[7px] sm:text-[9px] font-semibold uppercase tracking-wide whitespace-nowrap"
                        style={{
                          color: item.access === 'Free' ? '#9ca3af' : item.access === 'Members' ? '#34d399' : '#fb923c',
                          backgroundColor: item.access === 'Free' ? 'rgba(156,163,175,0.1)' : item.access === 'Members' ? 'rgba(52,211,153,0.1)' : 'rgba(251,146,60,0.1)',
                        }}
                      >
                        {item.access}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Analytics - full width */}
            <div className="md:col-span-3 bg-white/5 border border-white/10 rounded-xl p-4">
              <div className="flex items-center justify-between mb-4">
                <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">Analytics</h4>
                <div className="flex items-center gap-1">
                  {['Today', '7d', '30d', '90d'].map((period, i) => (
                    <span
                      key={period}
                      className={`text-[10px] px-2 py-0.5 rounded font-medium cursor-default ${
                        i === 1 ? 'bg-white/10 text-white' : 'text-gray-500 hover:text-gray-400'
                      }`}
                    >
                      {period}
                    </span>
                  ))}
                </div>
              </div>

              {/* Stat Cards Row */}
              <div className="grid grid-cols-3 md:grid-cols-6 gap-2 mb-4">
                {ANALYTICS_STATS.map((s, i) => (
                  <div key={i} className="p-2.5 rounded-lg bg-[#0d1117] border border-white/5">
                    <div className="flex items-center gap-1.5 mb-1.5">
                      <i className={`fas ${s.icon} text-[10px]`} style={{ color: s.color }}></i>
                      <span className="text-[10px] text-gray-500">{s.label}</span>
                    </div>
                    <div className="text-sm md:text-base font-bold" style={{ color: s.color }}>{s.value}</div>
                  </div>
                ))}
              </div>

              {/* Conversion Funnel */}
              <div className="mb-4 p-3 rounded-lg bg-[#0d1117] border border-white/5">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-xs text-white font-semibold">Conversion Funnel</p>
                  <div className="flex gap-2">
                    <span className="text-[10px] px-2 py-0.5 rounded bg-white/10 text-white font-medium cursor-default">Coaching</span>
                    <span className="text-[10px] px-2 py-0.5 rounded text-gray-500 cursor-default">Shop &amp; Downloads</span>
                  </div>
                </div>
                <div className="space-y-2">
                  {FUNNEL_STEPS.map((step, i) => (
                    <div key={i} className="flex items-center gap-3">
                      <div className="w-24 md:w-32 text-right shrink-0">
                        <p className="text-[10px] md:text-xs text-white font-medium leading-tight">{step.label}</p>
                        <p className="text-[9px] text-gray-500 hidden sm:block">{step.sub}</p>
                      </div>
                      <div className="flex-1 h-5 md:h-6 bg-white/5 rounded overflow-hidden relative">
                        <div
                          className="h-full rounded"
                          style={{
                            width: `${(step.events / 1247) * 100}%`,
                            background: i === 0
                              ? 'linear-gradient(90deg, #749555, #5a8a3c)'
                              : `linear-gradient(90deg, #749555, ${['#8bb85a', '#a3c46c', '#b8cc5e', '#c4b840'][i] || '#a3b86c'})`,
                          }}
                        ></div>
                        <span className="absolute inset-0 flex items-center pl-2 text-[10px] md:text-xs font-bold text-white drop-shadow-sm">
                          <span className="font-bold">{step.events.toLocaleString()}</span>
                          <span className="ml-1 font-normal opacity-80">events</span>
                        </span>
                      </div>
                      <span className="w-8 text-right shrink-0 text-[10px] md:text-xs font-medium text-chess-green">
                        {step.pct || ''}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Data Tables 2x2 Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {/* Sources */}
                <div className="p-3 rounded-lg bg-[#0d1117] border border-white/5">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs text-white font-semibold border-b border-chess-green pb-1">Sources</span>
                    <span className="text-[10px] text-gray-500 pb-1">Channels</span>
                    <span className="text-[10px] text-gray-500 pb-1">Referrers</span>
                  </div>
                  <div className="grid grid-cols-[1fr_auto_auto] gap-x-4 gap-y-1.5 text-[10px] md:text-xs">
                    <span className="text-gray-500 font-medium">Source</span>
                    <span className="text-gray-500 font-medium text-right">Visitors</span>
                    <span className="text-gray-500 font-medium text-right">Visits</span>
                    {SOURCES.map((s, i) => (
                      <React.Fragment key={i}>
                        <span className="text-gray-300">{s.name}</span>
                        <span className="text-gray-400 text-right">{s.visitors}</span>
                        <span className="text-gray-400 text-right">{s.visits.toLocaleString()}</span>
                      </React.Fragment>
                    ))}
                  </div>
                </div>

                {/* Top Pages */}
                <div className="p-3 rounded-lg bg-[#0d1117] border border-white/5">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs text-white font-semibold border-b border-chess-green pb-1">Top Pages</span>
                    <span className="text-[10px] text-gray-500 pb-1">Entry Pages</span>
                    <span className="text-[10px] text-gray-500 pb-1">Exit Pages</span>
                  </div>
                  <div className="grid grid-cols-[1fr_auto_auto] gap-x-4 gap-y-1.5 text-[10px] md:text-xs">
                    <span className="text-gray-500 font-medium">Page</span>
                    <span className="text-gray-500 font-medium text-right">Visitors</span>
                    <span className="text-gray-500 font-medium text-right">Pageviews</span>
                    {TOP_PAGES.map((p, i) => (
                      <React.Fragment key={i}>
                        <span className="text-gray-300 flex items-center gap-1.5 truncate">
                          {p.page}
                          {p.tag && <span className="text-[8px] bg-white/10 text-gray-400 px-1.5 py-0.5 rounded">{p.tag}</span>}
                        </span>
                        <span className="text-gray-400 text-right">{p.visitors}</span>
                        <span className="text-gray-400 text-right">{p.pageviews.toLocaleString()}</span>
                      </React.Fragment>
                    ))}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <button
            onClick={onGetStarted}
            className="px-8 py-3.5 bg-chess-green text-white rounded-xl font-bold text-lg hover:bg-opacity-90 transition-all shadow-lg shadow-chess-green/20 inline-flex items-center justify-center group"
          >
            Launch My Website
            <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default AcademyShowcase;
